"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throws an error on another job so that it's picked up by the runtime's
 * uncaught error handling mechanism.
 * @param err the error to throw
 */
function hostReportError(err) {
    setTimeout(function () {
        throw err;
    });
}
exports.hostReportError = hostReportError;
//# sourceMappingURL=hostReportError.js.map